let navbar__item = document.querySelectorAll('.navbar__item');

function removeAllClass(elements, className) {
  elements.forEach(function (el) {
    return el.classList.remove(className);
  });
}

function addClass(element, className) {
  return element.classList.add(className);
}

navbar__item.forEach(function(el){
  el.addEventListener('click', function(){
    removeAllClass(navbar__item, 'active');
    addClass(el, 'active');
  });
});